export default __webpack_public_path__ + "static/media/distanceWhite.9aea3b65.svg";